import { useCallback } from 'react';
import { useStateOnChange } from '@leverege/ui-hooks';
import { ExpressionEditor } from '@leverege/expression-editor';
import { Button, Content, Text } from '@leverege/ui-elements';
import RsrcFilterModel from "./RsrcFilterModel.js";
import S from './RsrcFilterModelEditor.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export default function RsrcFilterModelEditor(props) {
  const {
    value,
    onChange: pOnChange
  } = props;
  const [sValue, onChangeSValue] = useStateOnChange(RsrcFilterModel.getFilter(value, 'expression'));
  const onSubmit = useCallback(() => {
    pOnChange({
      value: RsrcFilterModel.setFilter(value || RsrcFilterModel.create(), 'expression', sValue)
    });
  }, [sValue, pOnChange, value]);
  return /*#__PURE__*/_jsxs(Content, {
    relative: true,
    children: [/*#__PURE__*/_jsx(Content.Header, {
      variant: "dialogHeader",
      children: /*#__PURE__*/_jsx(Text, {
        variant: "dialogTitle",
        children: "Edit Expression Filter"
      })
    }), /*#__PURE__*/_jsx(Content.Area, {
      variant: "dialogBody",
      children: /*#__PURE__*/_jsx(ExpressionEditor, {
        className: S.expressionEditor,
        value: sValue,
        onChange: onChangeSValue
      })
    }), /*#__PURE__*/_jsx(Content.Footer, {
      variant: "dialogFooter",
      layout: "flex:rowMEnd",
      children: /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        onClick: onSubmit,
        children: "Save"
      })
    })]
  });
}